import { Button, Card, Grid, Text } from '@mantine/core';
import { useParams } from 'react-router';

const TikTokConnectButton = () => {
  const { accountId, domainId } = useParams();

  const stateData = {
    accountId,
    domainId,
  };
  const encodedState = encodeURIComponent(btoa(JSON.stringify(stateData)));

  const authorizationURL = `https://business-api.tiktok.com/portal/auth?app_id=7530160270606336016&state=${encodedState}&redirect_uri=https%3A%2F%2Freleva.ai%2Fapi%2Fv0%2Ftiktok%2Fcallback`;
  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Text size="sm" fw={500}>Connection</Text>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <div style={{ marginTop: 'var(--mantine-spacing-sm)' }}>
              <Button component="a" href={authorizationURL} variant="filled">
                Connect TikTok to Releva
              </Button>
            </div>
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default TikTokConnectButton;
